module.exports = __webpack_public_path__ + "img/03.8ca5ba5e.png";